import { getRequest,getDownLoad, postUpLoad, postRequestJson } from "../utils/request"


// 录入信息
export function qsInfoPage(params){
  return getRequest('/jundaWebSite/qsInfo/page', params)
}

// 城市
export function selectCity(params){
  return getRequest('/jundaWebSite/select/city', params)
}

// 站点
export function selectSite(params){
  return getRequest('/jundaWebSite/select/site', params)
}

// 外卖平台
export function wpPlatform(params){
  return getRequest('/jundaWebSite/select/wpPlatform', params)
}

// 骑手类型
export function selectQsType(params){
  return getRequest('/jundaWebSite/select/qsType', params)
}

// 模板下载
export function downloadtpl(params){
  return getDownLoad('/jundaWebSite/qsInfo/downloadtpl', params)
}

// 骑手资源列表
export function qsResourcesPage(params){
  return getRequest('/jundaWebSite/qsResouces/page', params)
}

// 上传骑手信息
export function uploadQsInfo(params){
  return postUpLoad('/jundaWebSite/qsInfo/uploadQsInfo', params)
}

// 删除骑手信息
export function qsInfoDel(params){
  return postRequestJson('/jundaWebSite/qsInfo/del', params)
}

// 删除骑手资源库信息
export function qsZykInfoDel(params){
  return postRequestJson('/jundaWebSite/qsResouces/del', params)
}

// 不录入
export function no2Resources(params){
  return postRequestJson('/jundaWebSite/qsInfo/no2Resources', params)
}

// 覆盖更新
export function y2Resources(params){
  return postRequestJson('/jundaWebSite/qsInfo/y2Resources', params)
}


